module.exports = __webpack_public_path__ + "static/media/food.50cd35cd.png";